import React from 'react';
import {permissionCleaner} from '../../../../../../../../../../../../../../../../../../utils/index';
import './index.css';
import {connect} from "react-redux";

class DropDown extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			currentRight: this.props.right
		};

		this.permissions = [];
		this.changeRight = this.changeRight.bind(this);
	}

	changeRight(e){

		let cTarget = e.currentTarget;

		if(cTarget.checked){
			this.setState({
				currentRight: cTarget.dataset.rightName
			}, () => {
				this.props.getUpdatedRight(cTarget.dataset.rightName);
			})
		} else {
			if(cTarget.dataset.rightLevel > 0){
				this.setState({
					currentRight: this.permissions[this.permissions[cTarget.dataset.rightLevel -1].level].name
				}, () => {
					this.props.getUpdatedRight(this.permissions[this.permissions[cTarget.dataset.rightLevel -1].level].name);
				})
			}
		}

	}

	render(){

		if (
			this.props.selectedContactsGroup.type === "directory"
			|| this.props.selectedContactsGroup.type === "childDirectory"
			|| this.props.selectedContactsGroup.type === "childDirectoryLv2"
		) {
			if (this.props.selectedContactsGroup.directorySyncType === "DIRECTORY_LED"){
				this.permissions = [
					{
						id: 0,
						level: 1,
						name: 'READ_ONLY',
						rightsList: [
							{id: 0, level: 1, name: 'READ_ONLY', checked: true},
						]
					}
				];
			} else {
				this.permissions = [
					{
						id: 0,
						level: 3,
						name: 'WRITE_DELETE',
						rightsList: [
							{id: 2, level: 1, name: 'READ_ONLY', checked: true},
							{id: 1, level: 2, name: 'WRITE_ONLY', checked: true},
							{id: 0, level: 3, name: 'WRITE_DELETE', checked: true},
						]
					},
					{
						id: 1,
						level: 2,
						name: 'WRITE_ONLY',
						rightsList: [
							{id: 2, level: 1, name: 'READ_ONLY', checked: true},
							{id: 1, level: 2, name: 'WRITE_ONLY', checked: true},
							{id: 0, level: 3, name: 'WRITE_DELETE', checked: false},
						]
					},
					{
						id: 2,
						level: 1,
						name: 'READ_ONLY',
						rightsList: [
							{id: 2, level: 1, name: 'READ_ONLY', checked: true},
							{id: 1, level: 2, name: 'WRITE_ONLY', checked: false},
							{id: 0, level: 3, name: 'WRITE_DELETE', checked: false},
						]
					}
				];
			}
		} else {
			this.permissions = [
				{
					id: 0,
					level: 5,
					name: 'OWNER',
					rightsList: [
						{id: 4, level: 1, name: 'READ_ONLY', checked: true},
						{id: 3, level: 2, name: 'WRITE_ONLY', checked: true},
						{id: 2, level: 3, name: 'WRITE_DELETE', checked: true},
						{id: 1, level: 4, name: 'CAN_SHARE', checked: true},
						{id: 0, level: 5, name: 'OWNER', checked: true}
					]
				},
				{
					id: 1,
					level: 4,
					name: 'CAN_SHARE',
					rightsList: [
						{id: 4, level: 1, name: 'READ_ONLY', checked: true},
						{id: 3, level: 2, name: 'WRITE_ONLY', checked: true},
						{id: 2, level: 3, name: 'WRITE_DELETE', checked: true},
						{id: 1, level: 4, name: 'CAN_SHARE', checked: true},
						{id: 0, level: 5, name: 'OWNER', checked: false},
					]
				},
				{
					id: 2,
					level: 3,
					name: 'WRITE_DELETE',
					rightsList: [
						{id: 4, level: 1, name: 'READ_ONLY', checked: true},
						{id: 3, level: 2, name: 'WRITE_ONLY', checked: true},
						{id: 2, level: 3, name: 'WRITE_DELETE', checked: true},
						{id: 1, level: 4, name: 'CAN_SHARE', checked: false},
						{id: 0, level: 5, name: 'OWNER', checked: false},
					]
				},
				{
					id: 3,
					level: 2,
					name: 'WRITE_ONLY',
					rightsList: [
						{id: 4, level: 1, name: 'READ_ONLY', checked: true},
						{id: 3, level: 2, name: 'WRITE_ONLY', checked: true},
						{id: 2, level: 3, name: 'WRITE_DELETE', checked: false},
						{id: 1, level: 4, name: 'CAN_SHARE', checked: false},
						{id: 0, level: 5, name: 'OWNER', checked: false},
					]
				},
				{
					id: 4,
					level: 1,
					name: 'READ_ONLY',
					rightsList: [
						{id: 4, level: 1, name: 'READ_ONLY', checked: true},
						{id: 3, level: 2, name: 'WRITE_ONLY', checked: false},
						{id: 2, level: 3, name: 'WRITE_DELETE', checked: false},
						{id: 1, level: 4, name: 'CAN_SHARE', checked: false},
						{id: 0, level: 5, name: 'OWNER', checked: false},
					]
				}
			];
		}

		return (
			<div className="dropdown">
				<ul>
                    {
                        this.permissions.map(permission => (
                            permission.name === this.state.currentRight
                            ?
                                permission.rightsList.map((right) => {
                                    return (
                                    	<React.Fragment key={right.id}>
	                                        {right.name === "CAN_SHARE" ? <hr className="m-1"/> : null}
	                                        <li>
	                                            <div className="custom-control custom-checkbox">
	                                                <input
	                                                    type="checkbox"
	                                                    className="custom-control-input"
	                                                    onChange={this.changeRight}
	                                                    defaultChecked={right.checked}
	                                                    id={this.props.collaboratorId+right.id}
	                                                    data-right-level={right.level}
	                                                    data-right-name={right.name}
	                                                    disabled={
		                                                    right.level === 1
			                                                || (
	                                                            this.props.collaboratorType === "group"
	                                                            && right.name === "OWNER"
	                                                        ) || (
	                                                            /* If the user is not the Owner of the label */
	                                                            this.props.userPermission !== "OWNER"
	                                                            && right.name === "OWNER"
	                                                        ) || (
	                                                            /* If the collaborator is not on the same domain */
	                                                            this.props.internal === false
	                                                            && right.name === "OWNER"
	                                                        ) || (
	                                                            /* If the sync is not over */
	                                                            this.props.isSyncing && right.name === "OWNER"
	                                                        ) || (
	                                                            /* If My contact is selected */
	                                                            this.props.selectedContactsGroup.type === 'system' && right.name === "OWNER"
	                                                        ) || (
	                                                            /* If Directory contacts */
	                                                            this.props.selectedContactsGroup.type === 'directory' && right.name === "OWNER"
	                                                        )
	                                                    }
	                                                />
	                                                <label className="custom-control-label" htmlFor={this.props.collaboratorId+right.id}>{permissionCleaner(right.name)}</label>
	                                            </div>
	                                        </li>
	                                    </React.Fragment>
                                    )
                                })
                            :
                                null
                        ))
                    }
				</ul>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
        isSyncing: state.syncStatusReducer.isSyncing,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup
	}
};

export default connect(mapStateToProps)(DropDown);
